<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline" size="small">
                <el-form-item>
                    <el-input v-model.trim="search.name" placeholder="模糊搜索名称" @keyup.enter.native="Search"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model.trim="search.code" placeholder="套餐编号" @keyup.enter.native="Search"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.status" multiple placeholder="状态集合" @change="Search">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="search.region" clearable placeholder="区域" @change="Search">
                        <el-option label="cn" value="cn"></el-option>
                        <el-option label="eu" value="eu"></el-option>
                        <el-option label="us" value="us"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="Search">查询</el-button>
                </el-form-item>
            </el-form>
            <div>
                <router-link :to="'/iot/alarmpackadd/' + 0">
                    <el-button type="primary" size="small">新建</el-button>
                </router-link>
            </div>
        </div>
        <!-- 列表 -->
        <el-table border v-bind:data="list" @sort-change="Sortchange" size="small">
            <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
            <el-table-column label="套餐名称" sortable>
                <template v-slot="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐时长" sortable>
                <template v-slot="scope">
                    <span>{{
                        scope.row.time +
                        '(' +
                        scope.row.time_unit +
                        ')'
                        }}</span>
                </template>
            </el-table-column>
            <el-table-column label="套餐状态" width="200">
                <template v-slot="scope">
                    <el-select v-model="scope.row.status" @change="changeStatus(scope.row)" size="small">
                        <el-option label="测试" :value="0"></el-option>
                        <el-option label="上架" :value="1"></el-option>
                        <el-option label="下架" :value="2"></el-option>
                        <el-option label="已删除" :value="3"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column label="区域">
                <template v-slot="scope">
                    <span>{{ scope.row.region }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="280px">
                <template v-slot="scope">
                    <router-link style="margin-right:10px" :to="'/iot/alarmpackadd/' + scope.row.code">
                        <el-button type="primary" size="mini">修改</el-button>
                    </router-link>
                    <!-- <el-button type="danger" size="small" @click="deletePack(scope.row.SetMeal.code)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="search.page" :page-size="search.limit"
            layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>

<script type="text/ecmascript-6">
import api from '../../../axios/pack'
import util from '../../../util/util'
export default {
    name: '',
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            search: {
                page: 1,
                limit: 10,
                name: undefined,
                code: undefined,
                status: [0, 1],
                order_field: undefined,
                order_action: 1,
                region: undefined
            },
            list: [],
            total: 0,
            currencylist: []
        }
    },
    computed: {},
    watch: {},
    methods: {
        GetCurrency() {
            this.api.CurrencyList({
                page: 1,
                limit: 100,
            }).then(res => {
                if (res.data.code == 200) {
                    this.currencylist = res.data.data.data
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        Sortchange(column) {
            if (column.column) {
                switch (column.column.label) {
                    case '套餐名称':
                        this.search.order_field = 'name'
                        break
                    case '套餐时长':
                        this.search.order_field = 'time'
                        break
                    case '套餐价格/售价':
                        this.search.order_field = 'price'
                        break
                    case '币种':
                        this.search.order_field = 'currency'
                        break
                    case '文件时长(天)':
                        this.search.order_field = 'file_time'
                        break
                }
                this.search.order_action = column.order == "ascending" ? 1 : 2
            } else {
                this.search.order_field = undefined
                this.search.order_action = 1
            }
            this.Search()
        },
        handleCurrentChange(val) {
            this.search.page = val
            sessionStorage.setItem('currentPage', val)
            this.Search()
        },
        Search() {
            api.AlarmPackageList({
                page: this.search.page,
                limit: this.search.limit,
                kname: this.search.name,
                code: this.search.code,
                region: this.search.region || undefined,
                status: JSON.stringify(this.search.status),
                order_field: this.search.order_field,
                order_action: this.search.order_action,
            }).then(res => {
                console.log('PackageList: ', res)
                if (res.data.code == 200) {
                    this.list = res.data.data.list
                    this.total = res.data.data.page_info.total
                    return
                }
                this.$message.error('获取失败' + res.data.msg)
            })
        },
        changeStatus(item) {
            api.AlarmPackageUpdateStatus({
                code: item.code,
                status: item.status,
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success('状态修改成功')
                    this.Search()
                    return
                }
                this.$message.error('状态修改失败' + res.data.msg)
            })
        },
        deletePack(item) {
            this.$confirm('是否删除该套餐?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除请求
                api.PackDelete({ code: item }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                        this.Search()
                        return
                    }
                    this.$message.error('删除失败' + res.data.msg)
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消删除'
                })
            })
        },
        changeTime(item) {
            return util.dateFormat(item)
        },
        getSchoolWebModuleMessageListFunc() {
            setTimeout(() => {
                if (sessionStorage.getItem("currentPage") && sessionStorage.getItem("currentPage") !== 1) {
                    this.search.page = Number(sessionStorage.getItem("currentPage"))
                }
                this.Search()
            }, 0)
        }
    },
    filters: {},
    mounted() {
        this.getSchoolWebModuleMessageListFunc()
    },
    created() {
        this.GetCurrency()
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus"></style>
